// T010 — Resolve an email to a CoCharge wallet account identifier.
//
// The wallet API keys wallets by the user's `emaid` (the eMobility account
// identifier — same field shown on AppUserDetails). It is NOT the Auth0
// `user_id`; passing `auth0|...` or `google-oauth2|...` to /admin/wallets/{id}
// is the wrong call.
import { getCochargeUsersByEmail } from "../owners";

export interface AccountLookupResult {
  emaid: string;
  email: string;
  displayName?: string;
}

const isEmail = (value: string): boolean => /\S+@\S+/.test(value.trim());

export const resolveAccountFromEmail = async (
  email: string,
): Promise<AccountLookupResult | null> => {
  const trimmed = email.trim();
  if (!trimmed) return null;

  // One email can map to several accounts; take the first that has an emaid,
  // the same rule the notification admin screens use (useResolvedUser).
  const users = await getCochargeUsersByEmail(trimmed);
  const user = (users ?? []).find((u: any) => u?.emaid);
  if (!user) return null;

  return {
    emaid: user.emaid,
    email: user.email ?? trimmed,
    displayName: user.name ?? user.nickname ?? undefined,
  };
};

// The search bar accepts either an email or an emaid directly. Anything that
// is not an email is treated as an emaid and used verbatim.
export const looksLikeEmaid = (value: string): boolean => {
  const trimmed = value.trim();
  return trimmed.length > 0 && !isEmail(trimmed);
};
